import { memo, useCallback, useState } from "react";

import { classNames } from "helpers";
import { Button } from "ui/components/Button/Button";
import { CheckBox } from "ui/components/CheckBox";
import { FileUploadModal } from "ui/components/FileUpload/FileUploadModal";
import { EmailAttachmentsSectionProps } from "./types";



const EmailAttachmentsSection: React.FC<EmailAttachmentsSectionProps> = (props) => {
  const {
    formValues,
    setFormValues,
    onUploadSave,
  } = props;

  const { pdfAttachment, pdfAttachmentSelected, additionalFiles } = formValues;

  const [showUploadModal, setShowUploadModal] = useState<boolean>(false);

  const handleTogglePdfAttachment = useCallback(() => {
    setFormValues((prev) => ({
      ...prev,
      pdfAttachmentSelected: !prev.pdfAttachmentSelected,
    }));
  }, [setFormValues]);

  const handleToggleAdditionalFile = useCallback(
    (index: number) => () => {
      setFormValues((prev) => ({
        ...prev,
        additionalFiles: prev.additionalFiles.map((item, i) =>
          i === index ? { ...item, selected: !item.selected } : item
        ),
      }));
    },
    [setFormValues]
  );

  return (
    <>
      <div className="mb-4 border border-slate-200 rounded-sm">
        <div className="border-b border-slate-200 bg-slate-50 px-3 pt-2.5 pb-2 text-sm font-medium transition-colors duration-200 focus:outline-none relative text-sky-600">
          Privitak:
        </div>
        <div className="bg-white">
          {pdfAttachment && (
            <div className="flex items-center px-3 pt-2.5 pb-0.5 mt-[-1px] bg-white-50">
              <CheckBox
                name="pdfAttachment"
                checked={pdfAttachmentSelected}
                onChange={handleTogglePdfAttachment}
                label={pdfAttachment.title}
                disabled
              />
            </div>
          )}
          {additionalFiles.map((item, index) => (
            <div key={item.file.id} className={classNames("flex items-center border-y border-slate-200 px-3 pt-2.5 pb-0.5 mb-[-1px]", (index + 1) % 2 === 0 ? "bg-slate-50" : "bg-white")}>
              <CheckBox
                name={`additionalFile-${index}`}
                checked={item.selected}
                onChange={handleToggleAdditionalFile(index)}
                label={item.file.title ?? item.file.name}
              />
            </div>
          ))}
        </div>
        <div className="px-3 pt-4 pb-3 flex justify-end">
          <Button
            variant="primary"
            onClick={() => setShowUploadModal(true)}
            startIcon="/media/icons/plus.svg"
            children={"Dodaj privitak"}
            size="small"
          />
        </div>
      </div>

      <FileUploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        onSave={onUploadSave}
        title="Dodaj privitke"
      />
    </>
  );
};

export default memo(EmailAttachmentsSection);
